/** Public (no sign-in) client for bite-test-server's team access request route. */

export interface TeamRequestForm {
  firstName: string;
  lastName: string;
  email: string;
  team: string;
  /** Names the exact team, bypassing the by-name lookup that rejects ambiguous matches. */
  team_id?: string;
}

export async function submitTeamRequest(form: TeamRequestForm): Promise<string> {
  const response = await fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/v1/team-requests`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(form),
  });
  const body = (await response.json().catch(() => null)) as { message?: string; error?: string } | null;
  if (!response.ok) throw new Error(body?.error ?? "Could not process team request");
  return body?.message ?? "Your request is pending.";
}
